/**
 * 🛡️ safeStorage - QuotaExceededError ve Storage çökme koruması
 * Tarayıcı localStorage kotası (5MB) dolduğunda uygulamanın beyaz ekrana düşmesini
 * veya patlamasını engeller. Otomatik geçici önbellek temizliği ve fallback mekanizması içerir.
 */

// Bellek içi yedek (eğer localStorage tamamen kilitlenirse veya kota aşılırsa)
const memoryStorage = new Map();

export const safeStorage = {
  getItem: (key) => {
    try {
      const val = localStorage.getItem(key);
      if (val !== null) return val;
    } catch (_) {}
    return memoryStorage.get(key) || null;
  },

  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      memoryStorage.set(key, value);
    } catch (err) {
      console.warn(`⚠️ [safeStorage] localStorage.setItem('${key}') kota hatası verdi:`, err.name || err.message);

      // 1. Acil durum önbellek tahliyesi: Gereksiz/geçici anahtarları temizle
      try {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (
            k && (
              k.startsWith('qr_cached_') ||
              k.startsWith('temp_') ||
              k.startsWith('offline_') ||
              k.startsWith('cache_') ||
              k.startsWith('debug_') ||
              k.includes('history_') ||
              k.includes('logs_') ||
              k.length > 500
            )
          ) {
            keysToRemove.push(k);
          }
        }

        // Bulunan gereksiz anahtarları sil
        keysToRemove.forEach(k => {
          try { localStorage.removeItem(k); } catch (_) {}
        });

        // Temizlik sonrası tekrar dene
        localStorage.setItem(key, value);
        memoryStorage.set(key, value);
        return;
      } catch (retryErr) {
        console.warn(`⚠️ [safeStorage] Temizlik sonrası da yazılamadı, belleğe kaydedildi: ${key}`);
      }

      // 2. LocalStorage tamamen doluysa en azından memoryStorage'a yaz ki JS patlamasın
      memoryStorage.set(key, value);
    }
  },

  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (_) {}
    memoryStorage.delete(key);
  },

  clear: () => {
    try {
      localStorage.clear();
    } catch (_) {}
    memoryStorage.clear();
  }
};

export default safeStorage;
